import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#76a0fc";
function ANGLE({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" data-name="Calque 1" fill={color}><path d="M3.33 13.04l4.21 4.25 4.32-4.36s.03 0 .04-.02c0 0 0-.01.01-.02s.01 0 .02 0 .02-.02.04-.02.02.01.04.02h.02s0 .01.01.02c.01 0 .03 0 .04.02l4.32 4.36 4.21-4.25-8.64-8.71zm.49.91l.9 1.58 3.15 3.18-.45-1.12z"  fillRule="evenodd" /><path d="M12.12 15.56l3.48 3.52.62-1.54-4.1-4.13z"  fillRule="evenodd" /><path d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.62 0 12 0m8.95 13.11l-1.47 2.58s-.01.02-.02.03l-3.69 3.72-.06.03-.02.02c-.04 0-.07 0-.1-.02v-.01h-.01L12 15.85l-3.58 3.61h-.01v.01c-.03.02-.07.03-.1.02l-.02-.02q-.03 0-.06-.03l-3.69-3.72s-.02-.02-.02-.03l-1.47-2.58v-.08c0-.02.01-.04.02-.06 0-.01 0-.02.01-.03l8.78-8.93s.07-.04.11-.04.08.02.11.04l8.85 8.93s0 .02.01.03c.01.02.02.04.02.06v.08z"  fillRule="evenodd" /></Svg>;
}
ANGLE.DefaultColor = DefaultColor;
export default ANGLE;